import logger from 'utils/logger.util';

const L = logger('isTouchDevice');

// The 'heartz' as a way to have a non-matching MQ to help terminate the join
// SEE: https://github.com/Modernizr/Modernizr/issues/1814
const PREFIXES = ' -webkit- -moz- -o- -ms- '.split(' ').join('touch-enabled),(');
const QUERY = ['(', PREFIXES, 'heartz', ')'].join('');

const noop = () => void 1;
const addListener = noop;
const removeListener = noop;
const matchMedia = window.matchMedia || (() => ({ matches: false, addListener, removeListener }));

const mq = (query) => matchMedia(query).matches;

// The DocumentTouch interface used to provide convenience methods for creating Touch and TouchList objects,
// but DocumentTouch been removed from the standards.
// These two methods now live on the Document interface.

const IS_TOUCH_DEVICE =
  'ontouchstart' in window || (window.DocumentTouch && document instanceof window.DocumentTouch) ? true : mq(QUERY);

L.debug('()', 'IS_TOUCH_DEVICE:', IS_TOUCH_DEVICE);

const isTouchDevice = () => IS_TOUCH_DEVICE;

export default isTouchDevice;
